import { defaultBreakpointValues } from "../responsive/legacyBreakpoints";
var createWidthStyles = function (breakpointWidth, down) {
    var _a;
    return ({
        maxWidth: breakpointWidth,
        // Ensures enough space for scrollbar
        "&$paperScrollBody": (_a = {},
            _a[down(breakpointWidth + 64)] = { maxWidth: "calc(100% - 64px)" },
            _a),
    });
};
export var createMuiDialogOverrides = function (_a) {
    var palette = _a.palette, breakpoints = _a.breakpoints;
    return ({
        paper: {
            border: "1px solid ".concat(palette.divider),
            backgroundColor: palette.background.default,
            color: palette.text.secondary,
        },
        // TODO: Manually review these for V3
        // Ensuring new breakpoints don't affect dialog sizes
        paperWidthSm: createWidthStyles(defaultBreakpointValues.sm, breakpoints.down),
        paperWidthMd: createWidthStyles(defaultBreakpointValues.md, breakpoints.down),
        paperWidthLg: createWidthStyles(defaultBreakpointValues.lg, breakpoints.down),
        paperWidthXl: createWidthStyles(defaultBreakpointValues.xl, breakpoints.down),
    });
};
//# sourceMappingURL=MuiDialog.js.map